import {
    buildConfigSlice,
    useConfigSlice,
    WidgetConfigSliceActionPayloadType,
} from 'widgets/store/configuration/configSlice';

import { WidgetType } from 'widgets/WidgetType';
import {
    initialPortfolioReturnsConfigurationState,
    PortfolioReturnsConfigurationState,
} from 'widgets/portfolioReturns/store/configuration/PortfolioReturnsConfigurationState';
import { selectPortfolioReturnsState } from 'widgets/portfolioReturns/store/selectors';

export const buildPortfolioReturnsConfigSlice = () =>
    buildConfigSlice<PortfolioReturnsConfigurationState>(
        WidgetType.PORTFOLIO_RETURNS,
        selectPortfolioReturnsState,
        initialPortfolioReturnsConfigurationState
    );

export const usePortfolioReturnsConfigSlice = () =>
    useConfigSlice(buildPortfolioReturnsConfigSlice());

export type PortfolioReturnsConfigPayloadType =
    WidgetConfigSliceActionPayloadType<PortfolioReturnsConfigurationState>;
